<div class="modal-header">
    <div class="d-flex align-items-center gap-2">
        <div>
            <h4>Editar usuario</h4>
            <small class="text-muted">{{usuario?.nombre + ' '+ usuario?.apellido }}</small><br>
            <small class="text-muted" *ngIf="usuario?.roles?.[0]">Rol actual: <strong>{{ usuario?.roles?.[0]?.nombre }}</strong></small>
        </div>
    </div>
    <button
        type="button"
        class="btn-close"
        aria-label="Cerrar"
        (click)="cerrarSinGuardar()">
        <i class="bi bi-x-lg"></i>
    </button>
</div>

<div class="modal-body">

    <!-- Advertencia: dominio externo -->
    <div *ngIf="!dominioValido" class="alert alert-warning d-flex align-items-start gap-2 py-2">
        <i class="bi bi-exclamation-triangle-fill mt-1"></i>
        <span>
            Este usuario tiene un dominio externo. Su rol es <strong>Empresa</strong>
            y no puede ser modificado desde este panel.
        </span>
    </div>

    <!-- Advertencia: sin permiso de edición -->
    <div *ngIf="!tienePermiso" class="alert alert-danger d-flex align-items-start gap-2 py-2">
        <i class="bi bi-lock-fill mt-1"></i>
        <span>
            No tienes permisos para editar usuarios. Se requiere el rol
            <strong>Administrador usuarios</strong>.
        </span>
    </div>

    <form [formGroup]="form" novalidate [class.form-disabled]="!dominioValido || !tienePermiso">

        <!-- Campo: Rol -->
        <div class="mb-3">
            <label for="select-rol" class="form-label">
                Seleccione un rol
                <span class="text-danger">*</span>
            </label>
            <select
                id="select-rol"
                class="form-select"
                formControlName="rol"
                [class.is-invalid]="form.get('rol')?.invalid && form.get('rol')?.touched">
                <option value="">-- Seleccione un rol --</option>
                <option *ngFor="let rol of roles" [value]="rol.id">
                    {{ rol.nombre }}
                </option>
            </select>
            <div
                class="invalid-feedback"
                *ngIf="form.get('rol')?.invalid && form.get('rol')?.touched">
                Este campo es obligatorio.
            </div>
        </div>

        <!-- Campo: Fecha de inactivación -->
        <app-input-date
            label="Seleccione una fecha de inactivación"
            inputId="input-fecha"
            formControlName="fechaInactivacion"
            required
            [min]="fechaMinima"
            [submitted]="form.get('fechaInactivacion')?.touched"
            [requiredError]="fechaError">
        </app-input-date>

    </form>
</div>

<div class="modal-footer">
    <app-button
        label="Cerrar"
        variant="secondary"
        (clicked)="cerrarSinGuardar()">
    </app-button>
    <app-button
        label="Confirmar"
        variant="success"
        [disabled]="form.invalid || !dominioValido || !tienePermiso || guardando"
        (clicked)="confirmar()">
    </app-button>
</div>